import { Logger } from '@ps/common-features/sentry/loggerService'
import { apiClientBridge } from 'src/api/config/clientBridge'

import { TrackingDataSchema } from './schemas/serviceTracking.schema'
import { TrackingData } from './serviceTracking.types'

export const getServiceTracking = async (code: string): Promise<TrackingData> => {
  const response = await apiClientBridge.get(`v1/resident/request-tracking/${code}`)
  const result = TrackingDataSchema.safeParse(response.data)

  if (!result.success) {
    Logger.zodError(result.error, { context: { service: 'service-tracking', code } })

    throw result.error
  }

  return result.data
}
